export default __webpack_public_path__ + "static/media/medicamentos-disabled.9d1381cf.svg";